import "./Block.scss";

const Block = ({ id, header, text, image, alt, color, order }) => {
  return (
    <section id={id} className={`content-block ${color} ${order}`}>
      <div className={`Content__Block background--${color}`}>
        <div className="text_container">
          <h2 className="main_header luckiest-guy-regular">{header}</h2>

          <p>{text}</p>
        </div>

        <div className={`image-container ${order}`}>
          <img src={image} alt={alt} />
        </div>
      </div>
    </section>
  );
};

export default Block;
